import { useEffect, useState } from 'react';

import { Announcement } from '../../../../../../api-client';
import { IAnnouncementFormValidator, AnnouncementFormValidator } from '../validators/announcement-form-validator';

export interface IAnnouncementForm extends Announcement { }

const defaultValues = {
    displayName: ''
}

export const useAnnouncementForm = (onFormValidated: (values: IAnnouncementForm) => void) => {
    const [formValues, setFormValues] = useState<IAnnouncementForm>(defaultValues);

    const handleInitialize = (values: IAnnouncementForm) => setFormValues(values);

    const handleFormChange = (name: string, value: any) => setFormValues({
        ...formValues,
        [name]: value
    });

    const [formErrors, setFormErrors] = useState<IAnnouncementFormValidator>({});
    const [formValidated, setFormValidated] = useState<boolean>(false);

    const handleFormSubmit = () => {
        const validationResult = AnnouncementFormValidator.validateForm(formValues);

        setFormErrors(validationResult);
        setFormValidated(Object.keys(validationResult).length === 0);
    }

    useEffect(() => {
        Object.keys(formErrors).length === 0 && formValidated && onFormValidated(formValues);
    }, [formErrors]);

    return {
        handleInitialize,
        handleFormChange,
        formValues,
        handleFormSubmit,
        formErrors
    };
}